(function () {
    'use strict';

    angular.module("imApp").factory("selectOeeStateService", ['$ihttp', function ($ihttp) {
        let service = {
            savingToPreP2SelectOeeState: false,
            listSelectOeeStates: function (parms) {
                return $ihttp.post({
                    method: 252,
                    parameters: parms || {}
                });
            },
            saveToPage: function (item) {
                return $ihttp.post({
                    method: 253,
                    parameters: item
                });
            }
        };

        return service;
    }]);
})();
